export const STUDIO_MEDIA_ROOT = '/media/studio';

export const studioMediaPath = (filename) => {
	if (!filename) {
		return '';
	}

	const name = filename.replace(/^\/+/, '');

	if (name.startsWith(`${STUDIO_MEDIA_ROOT}/`)) {
		return name;
	}

	if (/^studio-gender\.mp4$/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/gender/videos/${name}`;
	}

	if (/^studio-(woman|trans|men)\.mp4$/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/gender/videos/${name}`;
	}

	if (/^studio-(woman|trans|men)(-sm\.webp|\.(png|jpeg|jpg))?$/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/gender/images/${name}`;
	}

	if (/^studio-ethnicity\.mp4$/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/ethnicity/videos/${name}`;
	}

	if (/^ethnicity-men-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/ethnicity/men/${name}`;
	}

	if (/^ethnicity-trans-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/ethnicity/trans/${name}`;
	}

	if (/^ethnicity-.*\.mp4$/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/ethnicity/woman/videos/${name}`;
	}

	if (/^ethnicity-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/ethnicity/woman/${name}`;
	}

	if (/^bodytype-woman-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/bodytype/woman/${name}`;
	}

	if (/^bodytype-men-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/bodytype/men/${name}`;
	}

	if (/^hairstyle-woman-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/hairstyle/woman/${name}`;
	}

	if (/^hairstyle-men-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/hairstyle/men/${name}`;
	}

	if (/^hairstyle-trans-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/hairstyle/trans/${name}`;
	}

	if (/^haircolor-woman-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/haircolor/woman/${name}`;
	}

	if (/^haircolor-men-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/haircolor/men/${name}`;
	}

	if (/^haircolor-trans-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/haircolor/trans/${name}`;
	}

	if (/^eyecolor-woman-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/eyecolor/woman/${name}`;
	}

	if (/^eyecolor-men-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/eyecolor/men/${name}`;
	}

	if (/^breastsize-woman-/.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/breastsize/woman/${name}`;
	}

	if (/^(soft-ai-logo-transparent|coin-spark)\./.test(name)) {
		return `${STUDIO_MEDIA_ROOT}/brand/${name}`;
	}

	return `${STUDIO_MEDIA_ROOT}/${name}`;
};
